var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicalScholarshipsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19.429,
    viewBox: "0 0 17 19.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-doctor-solid",
    d: "M8.5,9.714A4.857,4.857,0,1,0,3.643,4.857,4.857,4.857,0,0,0,8.5,9.714ZM4.857,11.809A6.767,6.767,0,0,0,0,18.3a1.127,1.127,0,0,0,1.127,1.127H15.873A1.127,1.127,0,0,0,17,18.3a6.767,6.767,0,0,0-4.857-6.493v1.928a2.431,2.431,0,0,1,1.821,2.353v1.518a.609.609,0,0,1-.607.607H12.75a.607.607,0,1,1,0-1.214v-.911a1.214,1.214,0,0,0-2.429,0V17a.607.607,0,1,1,0,1.214H9.714a.609.609,0,0,1-.607-.607V16.089a2.431,2.431,0,0,1,1.821-2.353V11.57q-.342-.034-.694-.034H6.766q-.353,0-.694.034v2.482a2.125,2.125,0,1,1-1.214,0ZM5.464,17a.911.911,0,1,0-.911-.911A.911.911,0,0,0,5.464,17Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalScholarshipsIcon);
export default __webpack_public_path__ + "static/media/medical-scholarships-icon.4eaa7fe6e1c00ac236fb4d46d77075a3.svg";
export { ForwardRef as ReactComponent };